/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileTypeEnumSchema } from "./fileTypeEnumSchema.ts";
import { z } from "zod";

export const fileModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор файла"),
"name": z.string().describe("Имя"),
"type": z.lazy(() => fileTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Picture</b>: Картинка</li>\n<li><b>2 - Track</b>: Аудио-файл</li>\n<li><b>3 - Document</b>: Документ</li>\n</ul>\n"),
"path": z.string().describe("Путь до файла"),
"extension": z.string().describe("Расширение файла"),
"duration": z.number().int().describe("Длительность").nullable().nullish(),
"aspectRatio": z.number().describe("Соотношение сторон").nullable().nullish(),
"dominantColor": z.string().describe("Доминантный цвет").nullable().nullish(),
"bucket": z.string().describe("Бакет"),
"url": z.string().describe("S3 Url"),
"cdnUrl": z.string().describe("CDN Url"),
"fullS3Url": z.string().describe("Ссылка на файл в S3"),
"fullCdnUrl": z.string().describe("Ссылка на файл в cdn")
    })